import { store } from '@betacrew/jars-flux'
export const componentKey = "FORMS/SUBMIT_RECONCILIATION/LISTING";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        updatePaginationState: (state, action) => {
            state.paginationState = { ...state.paginationState, ...action.payload }
        },
        setListRecords: (state, action) => {
            state.listRecords = action.payload;
        },
        setTempFormFieldsList: (state, action) => {
            state.tempFormFieldsList = [...action.payload];
        },
        setOnDependentFields: (state, action) => {
            state.onDependentFields = action.payload;
        },
        setToCreateFormData: (state, action) => {
            state.toCreateFormData = { ...state.toCreateFormData, ...action.payload };
        },
        setFormsPreLoadedData: (state, action) => {
            state.formsPreLoadedData = action.payload;
        },
        updateFormsPreLoadedData: (state, action) => {
            state.formsPreLoadedData = {
                ...state.formsPreLoadedData,
                ...action.payload,
            }
        },
        updateUserInteractionPopupWResponseObj: (state, action) => {
            state.userInteractionPopupWResponseObj = {
                ...state.userInteractionPopupWResponseObj,
                ...action.payload,
            };
        },
        resetUserInteractionPopupWResponseObj: (state, action) => {
            state.userInteractionPopupWResponseObj = {};
        },
        setSuccessfullySubmittedReconciliation: (state, action) => {
            state.successfullySubmittedReconciliation = action.payload;
        },
        setFormDataFromRecordId: (state, action) => {
            state.formDataFromRecordId = action.payload;
        },
        setIsIncorrectFormRecordId: (state, action) => {
            state.isIncorrectFormRecordId = action.payload;
        },
        setIsReconciliationEditModeOn: (state, action) => {
            state.isReconciliationEditModeOn = action.payload;
        },
        setReconciliationAmount: (state, action) => {
            state.reconciliationAmount = action.payload;
        },
        setOpenReconciliationPaymentDrawer: (state, action) => {
            state.openReconciliationPaymentDrawer = action.payload;
        },
        setScheduleReconciliationDate: (state, action) => {
            state.scheduleReconciliationDate = action.payload;
        },
        setStateWitheldPaymentFrequency: (state, action) => {
            state.stateWitheldPaymentFrequency = action.payload;
        },
        setShowStateWitheldPaymentFrequencyPopup: (state, action) => {
            state.showStateWitheldPaymentFrequencyPopup = action.payload;
        },
        setReconPopupOptions: (state, action) => {
            state.reconPopupOptions = action.payload;
        },
    }, 
    initialReducerState: {
        loadingState: false,
        paginationState: {
            pageNumber: 1,
            pageSize: 10,
            skip: 0,
            sorts: [],
            total: 10,
        },
        listRecords: [],
        tempFormFieldsList: [],
        onDependentFields: {},
        formsPreLoadedData: {},
        toCreateFormData: {
            selectedYear: null,
            selectedForm: null,
            selectedState: null,
            selectedPayer: null,
        },
        userInteractionPopupWResponseObj: {},
        successfullySubmittedReconciliation: false,
        formDataFromRecordId: null,
        isIncorrectFormRecordId: null,
        isReconciliationEditModeOn: false,
        reconciliationAmount: null,
        openReconciliationPaymentDrawer: false,
        scheduleReconciliationDate: "",
        stateWitheldPaymentFrequency: {},
        showStateWitheldPaymentFrequencyPopup: false,
    }
});
export const {
    setLoadingState,
    updatePaginationState,
    setListRecords,
    setTempFormFieldsList,
    setFormsPreLoadedData,
    updateFormsPreLoadedData,
    setOnDependentFields,
    updateUserInteractionPopupWResponseObj,
    resetUserInteractionPopupWResponseObj,
    setToCreateFormData,
    setSuccessfullySubmittedReconciliation,
    setFormDataFromRecordId,
    setIsIncorrectFormRecordId,
    setIsReconciliationEditModeOn,
    setReconciliationAmount,
    setOpenReconciliationPaymentDrawer,
    setScheduleReconciliationDate,
    setStateWitheldPaymentFrequency,
    setShowStateWitheldPaymentFrequencyPopup,
} = actions;